module.exports = __webpack_public_path__ + "static/media/ex1-slow.8d37d37c.mp3";